import { Icon, Loading } from '@fourthwall/components';
import { SpotifyIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './SyncingBar.styled';
export const SyncingBar = ({ loading }) => (React.createElement(Loading, { isLoading: loading },
    React.createElement(S.Container, null,
        React.createElement(S.IconContainer, null,
            React.createElement(Icon, { component: SpotifyIcon, height: 20 })),
        React.createElement("div", null,
            React.createElement(S.Status, null,
                React.createElement(S.Title, null, "Syncing to Spotify")),
            React.createElement(S.Info, null, "Your podcast has been submitted. It will take about an hour before it\u2019s visible on Spotify.")))));
